// src/types/entities.ts
var Marketplace = {
  US: "US",
  CA: "CA",
  MX: "MX",
  BR: "BR",
  UK: "UK",
  DE: "DE",
  FR: "FR",
  IT: "IT",
  ES: "ES",
  NL: "NL",
  SE: "SE",
  PL: "PL",
  TR: "TR",
  AE: "AE",
  SA: "SA",
  IN: "IN",
  SG: "SG",
  AU: "AU",
  JP: "JP"
};
var SyncStatus = {
  IDLE: "IDLE",
  SYNCING: "SYNCING",
  ERROR: "ERROR"
};
var ProductCondition = {
  NEW: "NEW",
  USED_LIKE_NEW: "USED_LIKE_NEW",
  USED_VERY_GOOD: "USED_VERY_GOOD",
  USED_GOOD: "USED_GOOD",
  USED_ACCEPTABLE: "USED_ACCEPTABLE",
  REFURBISHED: "REFURBISHED"
};
var ProductStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
var ProductType = {
  STANDARD: "STANDARD",
  KIT: "KIT",
  KIT_COMPONENT: "KIT_COMPONENT"
};
var SupplierCostBasis = {
  GROSS_BEFORE_REBATE: "GROSS_BEFORE_REBATE",
  NET_AFTER_REBATE: "NET_AFTER_REBATE",
  UNKNOWN: "UNKNOWN"
};
var FulfillmentChannel = {
  FBA: "FBA",
  FBM: "FBM"
};
var ListingStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  SUPPRESSED: "SUPPRESSED"
};
var RepriceStatus = {
  REPRICING: "REPRICING",
  NOT_REPRICING: "NOT_REPRICING",
  PAUSED: "PAUSED"
};
var ShipmentPlanStatus = {
  DRAFT: "DRAFT",
  WORKING: "WORKING",
  SHIPPED: "SHIPPED",
  CANCELLED: "CANCELLED"
};
var ShipmentStatus = {
  DRAFT: "DRAFT",
  WORKING: "WORKING",
  SHIPPED: "SHIPPED",
  RECEIVING: "RECEIVING",
  RECEIVED: "RECEIVED",
  CANCELLED: "CANCELLED"
};
var ShipmentType = {
  SPD: "SPD",
  LTL: "LTL",
  FTL: "FTL"
};
var PrepType = {
  SELLER_LABEL: "SELLER_LABEL",
  AMAZON_LABEL: "AMAZON_LABEL"
};
var AlertType = {
  RESTOCK_URGENT: "RESTOCK_URGENT",
  RESTOCK_WARNING: "RESTOCK_WARNING",
  PRICE_BELOW_MIN: "PRICE_BELOW_MIN",
  NON_COMPETITIVE: "NON_COMPETITIVE",
  INVENTORY_AGE: "INVENTORY_AGE",
  SYNC_ERROR: "SYNC_ERROR",
  LISTING_SUPPRESSED: "LISTING_SUPPRESSED",
  LOW_BUY_BOX_SHARE: "LOW_BUY_BOX_SHARE"
};
var AlertSeverity = {
  RED: "RED",
  YELLOW: "YELLOW",
  INFO: "INFO"
};
var InventoryLocationType = {
  FBA: "FBA",
  LOCAL: "LOCAL"
};
var PurchaseOrderStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  PARTIAL: "PARTIAL",
  RECEIVED: "RECEIVED",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED"
};
var ComposedCostMode = {
  DERIVED: "DERIVED",
  OVERRIDE: "OVERRIDE"
};
var ListingFlag = {
  RED: "RED",
  ORANGE: "ORANGE",
  YELLOW: "YELLOW",
  PURPLE: "PURPLE",
  BLUE: "BLUE",
  NONE: "NONE"
};

// src/types/inventoryAudit.ts
var INVENTORY_AUDIT_ACTIONS = [
  "LOCAL_ADJUSTMENT",
  "MASTER_OPENING_BALANCE",
  "MASTER_PO_RECEIPT",
  "MASTER_PO_RECEIPT_CORRECTION",
  "PO_RECEIPT_CORRECTION",
  "MASTER_MANUAL_ADJUSTMENT",
  "DRAFT_RESERVATION",
  "DRAFT_RELEASE",
  "BUILD_CONSUMPTION",
  "UNBUILD_REVERSAL",
  "MASTER_DEMOTION",
  "PO_SHIPMENT_RECONCILIATION",
  "PURCHASE_ORDER_DELETED",
  "PURCHASE_ORDER_ITEM_DELETED",
  "PURCHASE_ORDER_RECONCILIATION_REVERSED"
];
var INVENTORY_AUDIT_ACTION_LABELS = {
  LOCAL_ADJUSTMENT: "Stock level edited",
  MASTER_OPENING_BALANCE: "Opening balance recorded",
  MASTER_PO_RECEIPT: "Purchase order received",
  MASTER_PO_RECEIPT_CORRECTION: "Purchase order receipt corrected",
  PO_RECEIPT_CORRECTION: "Purchase order receipt corrected",
  MASTER_MANUAL_ADJUSTMENT: "Master stock adjusted",
  DRAFT_RESERVATION: "Stock reserved for shipment draft",
  DRAFT_RELEASE: "Shipment reservation released",
  BUILD_CONSUMPTION: "Components consumed for build",
  UNBUILD_REVERSAL: "Build inventory restored",
  MASTER_DEMOTION: "Master stock transferred",
  PO_SHIPMENT_RECONCILIATION: "Purchase order reconciled to shipment",
  PURCHASE_ORDER_DELETED: "Purchase order inventory removed",
  PURCHASE_ORDER_ITEM_DELETED: "Purchase order item inventory removed",
  PURCHASE_ORDER_RECONCILIATION_REVERSED: "Purchase order reconciliation reversed"
};

export {
  Marketplace,
  SyncStatus,
  ProductCondition,
  ProductStatus,
  ProductType,
  SupplierCostBasis,
  FulfillmentChannel,
  ListingStatus,
  RepriceStatus,
  ShipmentPlanStatus,
  ShipmentStatus,
  ShipmentType,
  PrepType,
  AlertType,
  AlertSeverity,
  InventoryLocationType,
  PurchaseOrderStatus,
  ComposedCostMode,
  ListingFlag,
  INVENTORY_AUDIT_ACTIONS,
  INVENTORY_AUDIT_ACTION_LABELS
};
